// extracted by mini-css-extract-plugin
export default {"title":"CancelAutoRenewalModal__title--aB8ci","subtitle":"CancelAutoRenewalModal__subtitle--2tf4B","button":"CancelAutoRenewalModal__button--3xclA"};